import { Component, inject, Input } from '@angular/core';
import { GbTheme, THEME_SIGNAL } from '../../interfaces/theme';

@Component({
  selector: 'app-section-tag',
  imports: [],
  templateUrl: './section-tag.component.html',
  styleUrl: './section-tag.component.scss',
})
export class SectionTagComponent {
  @Input() text: string = '';
  public GbTheme = GbTheme;
  public theme = inject(THEME_SIGNAL);
}
